

// Menu for Resume Page

const editprofile = { id: 'h1', label: 'Edit Profile', icon: 'home'};
// Resume templates
const classic = { id: 'h1', label: 'Classic', icon: 'home'};
const gravity = { id: 'h2', label: 'Gravity', icon: 'shine'};
const elegant = { id: 'h3', label: 'Elegant', icon: 'video-clapper'};
const modern = { id: 'h4', label: 'Modern', icon: 'book'};
const executive = { id: 'h5', label: 'Executive', icon: 'support' };
const pro = { id: 'h6', label: 'Pro', icon: 'help' };

// Resume templates
const elegant1 = { id: 'h1', label: 'Elegant 1', icon: 'home'};
const elegant2 = { id: 'h2', label: 'Elegant 2', icon: 'shine'};
const gravity1 = { id: 'h3', label: 'Gravity 1', icon: 'video-clapper'};
const modern1 = { id: 'h4', label: 'Modern 1', icon: 'book'};


// End of Menu for Resume Page

export default {
  main: {
    id: 'main',
    content: [
      {
        label: 'Edit Profile',
        content: [editprofile],
      },
      {
        label: 'Seeker View',
        content: [classic],
      },
      {
        label: 'Create New',
        content: [gravity, elegant, modern, executive, pro],
      },
      {
        label: 'View Saved',
        content: [elegant1, elegant2, gravity1, modern1],
      },      
    ],
  },

  

};
